import {graphql} from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import * as tracking from '../../tracking';
import {trackAndCommitMutation} from '../../tracking/amplitude/TrackMutation';

const mutation = graphql`
	mutation unmarkProjectAsFavoriteMutation($input: UnmarkProjectAsFavoriteInput!) {
		unmarkProjectAsFavorite(input: $input) {
			unmarkedProjectId
			project {
				node {
					id
					userRelationTypes
				}
			}
		}
	}
`;

function getConfigs(input) {
	const configs = [];

	configs.push({
		type: 'RANGE_DELETE',
		parentID: 'Vmlld2VyOnFsZGZqYmUyNDM0UlpSRmVlcmc=',
		connectionKeys: [
			{
				key: 'favorite_psProjects',
			},
		],
		pathToConnection: ['viewer', 'psProjects'],
		deletedIDFieldName: 'unmarkedProjectId',
	});

	return configs;
}

function commit(environment, input, onSuccess, onError, uploadables) {
	tracking.trackEvent('Unmark project as favorite');

	const variables = {
		input: {
			csrfToken: Util.getCsrfValue(),
			socketClientId: Util.getClientId(),
			projectId: input.projectId,
		},
	};

	return trackAndCommitMutation(environment, {
		mutation,
		variables,
		uploadables,
		configs: getConfigs(input),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
